import {
  Input,
  Select,
  SelectItem,
  Textarea,
  RadioGroup,
  Radio,
  Button,
  Spinner,
} from "@nextui-org/react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { GoDash } from "react-icons/go";
import { IoMdAdd, IoMdArrowBack } from "react-icons/io";
import CreatableSelect from "react-select/creatable";
import { toast } from "react-toastify";
import axios from "axios";

/* Redux / Router */
import { useDispatch, useSelector } from "react-redux";
import { refreshIfNeeded } from "../../store/actions/refreshIfNeeded";

import { useNavigate, useParams } from "react-router-dom";

/* Project files */
import QuoteLayout from "../../layouts/QuoteLayout";
import { inputStyle, inputWrapperStyle } from "../../data/inputStyleData";
import {
  getAllPartType,
  getMake,
  getMode,
} from "../../store/slices/customerSlice";
import { getFormData } from "../../store/slices/formSlice";
import {
  getBodyStyle,
  getFuelType,
  getTransmission,
} from "../../store/slices/adminSlice";
import { imageResizer } from "../../utils";
import "./Request.css";
import { useEffect, useState } from "react";

const RequestGen = () => {
  //   const {
  //     control,
  //     register,
  //     handleSubmit,
  //     watch,
  //     formState: { errors },
  //     reset,
  //   } = useForm({
  //     defaultValues: {
  //       parts: [{ part_id: 0, quantity: 1 }],
  //     },
  //   });

  const {
    // NEW  (👇 two changes)
    control,
    register,
    handleSubmit,
    watch,
    setValue, // ➊  added – lets us clear fields programmatically
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      parts: [{ part_id: "", quantity: 1 }],
      /* ➋ start all three vehicle-ID inputs empty so they stay in sync */
      rego: "",
      vin: "",
      prof_descreption: "",
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "parts",
  });

  const [customFields, setCustomFields] = useState([]);
  const [customMake, setCustomMake] = useState([]);
  const [show, setShow] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [showModel, setShowModel] = useState(false);
  const [removeVisible, setRemoveVisible] = useState(true);
  const { makes, model, part_type } = useSelector((state) => state.customer);
  const [isSubmitting, setIsSubmitting] = useState(false);

  /* ---------------- vehicle selection ---------------- */
  const [showVehicleDetails, setShowVehicleDetails] = useState(true);
  const [vehicleOpt, setVehicleOpt] = useState("rego");
  /* --------------------------------------------------- */

  const { body_style, fuel_type, transmission } = useSelector(
    (state) => state.admin
  );

  const user = useSelector((state) => state.customer);
  const formData = useSelector((state) => state.form.formData);
  const [images, setImages] = useState([]);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState(null);
  const [customName, setCustomName] = useState("");
  const [combinedOption, setCombinedOption] = useState([]);
  const [options, setOptions] = useState([]);
  const { id } = useParams();
  const authHeaders = () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      "Content-Type": "multipart/form-data",
    },
  });
  const ensureAuth = async () => {
    await dispatch(refreshIfNeeded());
    return authHeaders();
  };

  let usersDetails = JSON.parse(localStorage.getItem("user_details"));

  const getModelByMakeId = (id) => {
    dispatch(getMode(id));
  };

  const addCustomField = () => {
    append({ part_id: "", quantity: 1 });
    setRemoveVisible(true);
    setCustomFields([watch("parts"), { part_type: "", quantity: 1 }]);
  };

  const addCustomMake = () => {
    setShow(!show);
    setCustomMake([...customMake, { custom_make: "", custom_model: "" }]);
  };

  const addCustomModel = () => {
    setShowModel(true);
  };

  // ⬇️ NEW – Make / Custom‑Make ki current value lete raho
  const makeValue = watch("make");
  const customMakeValue = watch("custom_make");
  const hasMakeSelected = !!makeValue || !!customMakeValue;

  const dataUrlToBlog = (dataUrl) => {
    const byteString = atob(dataUrl?.split(",")[1]);

    const mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];

    const ab = new ArrayBuffer(byteString.length);

    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        resolve(e.target.result);
      };
      fileReader.readAsDataURL(file);

      fileReader.onerror = (error) => reject(error);
    });
  };

  const getForm = () => {
    const fileURL = localStorage.getItem("fileURL");
    const imageBlob = dataUrlToBlog(fileURL);
    const formData = new FormData();
    formData.append("image", imageBlob);
  };

  useEffect(() => {
    const initialOptions = part_type
      .filter((item) => item?.id !== 0)
      .map((item) => ({ value: item.id, key: item.id, label: item.name }));
    setOptions(initialOptions);
  }, [part_type]);

  useEffect(() => {
    if (vehicleOpt === "rego") {
      setValue("vin", "");
      setValue("prof_descreption", "");
    } else if (vehicleOpt === "vin") {
      setValue("rego", "");
      setValue("prof_descreption", "");
    } else if (vehicleOpt === "note") {
      setValue("rego", "");
      setValue("vin", "");
    }
  }, [vehicleOpt, setValue]);

  const handleCreate = (inputValue) => {
    setCustomName(inputValue.label);
    setCombinedOption((prev) => [...prev, inputValue.label]);
  };

  const handleChange = (e, index) => {
    if (e.key) {
      setSelectedId(e.key);
    } else {
      setCustomName(e);
      setCombinedOption((prev) => [...prev, e]);
    }
  };

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    const token = localStorage.getItem("accessToken");
    let validParts = data.parts.filter(
      (p) => p.part_id !== "" && p.part_id !== undefined && p.part_id !== null
    );
    // agar ek bhi valid part nahi hai to error dikhao
    if (!validParts.length) {
      toast.error("Please select at least one part type!");
      setIsSubmitting(false);
      return; // <- submit rok do
    }

    if (vehicleOpt === "rego") {
      delete data.vin;
      delete data.prof_descreption;
    } else if (vehicleOpt === "vin") {
      delete data.rego;
      delete data.prof_descreption;
    } else if (vehicleOpt === "note") {
      delete data.rego;
      delete data.vin;
    }
    // let parts = data.parts;

    let parts = [];
    let total_data = {};
    if (data.make && data.model) {
      total_data = {
        ...data,
        make: data.make,
        model: data.model,
      };

      delete total_data.custom_make;
      delete total_data.custom_model;
    } else if (data.make && data.custom_model) {
      total_data = {
        ...data,
        make: data.make,
        custom_model: data.custom_model,
      };
      delete total_data.custom_make;
      delete total_data.model;
    } else if (data.custom_make && data.custom_model) {
      total_data = {
        ...data,
        custom_make: data.custom_make,
        custom_model: data.custom_model,
      };
      delete total_data.make;
      delete total_data.model;
    }

    if (!token) {
      const { images } = data;
      const file = images[0];
      const fileURL = await convertToBase64(file);
      let files = [];
      for (let i = 0; i < images.length; i++) {
        const fileURL = await convertToBase64(images[i]);
        files.push(fileURL);
      }
      total_data = {
        ...total_data,
        images: files,
      };
      localStorage.setItem("fileURL", files);
      dispatch(getFormData(total_data));
    } else {
      total_data = {
        ...total_data,
        images: images,
      };
    }

    parts = validParts.map((e) => {
      if (!isNaN(e.part_id)) {
        return e;
      } else {
        return {
          custom_part_type: e.part_id,
          quantity: e.quantity,
        };
      }
    });

    total_data = {
      ...total_data,
      parts: parts,
    };

    try {
      if (token) {
        // 1st attempt (with refreshed token)
        const headers = await ensureAuth();
        let res;
        try {
          res = await axios.post(
            `${process.env.REACT_APP_SERVER_URL_V2}/requests/create`,
            total_data,
            headers
          );
        } catch (err) {
          // if 401 aa gaya to ek baar aur refresh + retry
          if (err?.response?.status === 401) {
            const headers2 = await ensureAuth();
            res = await axios.post(
              `${process.env.REACT_APP_SERVER_URL_V2}/requests/create`,
              total_data,
              headers2
            );
          } else {
            throw err;
          }
        }
        toast.success("Created successfully ⭐");
        setTimeout(() => {
          navigate("/requests");
          localStorage.removeItem("total_data");
        }, 1000);
      } else {
        setTimeout(() => {
          navigate("/signup/CUSTOMER");
        }, 1000);
      }
    } catch (error) {
      let err = error.response?.data?.message;
      toast.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const data = JSON.parse(localStorage.getItem("total_data"));

  // const uploadImage = async (event) => {
  //   const files = event.target.files;

  //   if (files && files.length > 0) {
  //     const fileArray = Array.from(files).slice(0, 5);
  //     fileArray.forEach((image_file) => {
  //       imageResizer(image_file, setImages);
  //     });
  //   }
  // };
  const uploadImage = (e) => {
    const files = Array.from(e.target.files);

    if (files.length + images.length > 5) {
      toast.error("Max 5 images allowed");
      return;
    }

    files.forEach((file) => imageResizer(file, setImages));
  };
  useEffect(() => {
    dispatch(getMake());
    dispatch(getAllPartType());
    dispatch(getBodyStyle());
    dispatch(getFuelType());
    dispatch(getTransmission());
  }, [dispatch]);

  return (
    <div>
      <div>
        <h1 className="text-2xl text-center font-semibold">Create Request:</h1>
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <QuoteLayout heading={""}>
            {/* -------------------- Make selection -------------------- */}
            {!show ? (
              <div className="mb-2 md:mb-0">
                <Select
                  // isDisabled={!hasMakeSelected}
                  labelPlacement={"outside"}
                  placeholder="Make"
                  variant="bordered"
                  className="w-full outline-none mb-2"
                  label="Make"
                  value={`${data?.make}`}
                  isRequired={true}
                  {...register("make", { required: true })}
                >
                  {errors.make && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.make.message}
                    </p>
                  )}

                  {makes.map(
                    (item) =>
                      item?.id !== 0 && (
                        <SelectItem
                          key={item.id}
                          value={Number(item.id)}
                          onClick={() => getModelByMakeId(item.id)}
                          className="capitalize"
                        >
                          {item.name.toLowerCase()}
                        </SelectItem>
                      )
                  )}
                </Select>
                {errors.make && (
                  <p className="text-xs text-red-500 pl-2 pt-2">
                    Select the makes
                  </p>
                )}
                <button
                  className="flex items-center gap-2 text-small"
                  type="button"
                  onClick={addCustomMake}
                >
                  <IoMdAdd />{" "}
                  <p className="text-md sm:text-xs">
                    If Your Vehicle Make Isn't listed, Click Here To List
                  </p>
                </button>
              </div>
            ) : (
              <div>
                <Input
                  type="text"
                  label="Custom Make"
                  variant="bordered"
                  className="mb-2 "
                  labelPlacement={"outside"}
                  placeholder="Custom Make"
                  {...register("custom_make", { required: false })}
                />
                <button
                  className="flex items-center gap-2 text-small"
                  type="button"
                  onClick={addCustomMake}
                >
                  <IoMdAdd />{" "}
                  <p className="text-md sm:text-xs">Add listed Vehicle Make</p>
                </button>
              </div>
            )}

            {/* -------------------- Model selection -------------------- */}
            {/* {!show && !showModel ? (
              <div className="mb-2 md:mb-0">
                <Select
                  isDisabled={!hasMakeSelected}
                  labelPlacement={"outside"}
                  variant="bordered"
                  className="w-full mb-2"
                  label="Model"
                  placeholder={hasMakeSelected ? "Model" : "Select make first"}
                  isRequired={true}
                  {...register("model", { required: true })}
                >
                  {model.map(
                    (item) =>
                      item?.id !== 0 && (
                        <SelectItem key={item.id} className="capitalize">
                          {item.name.toLowerCase()}
                        </SelectItem>
                      )
                  )}
                </Select>
                {errors.model && (
                  <p className="text-xs text-red-500 pl-2 pt-2">
                    Select the model
                  </p>
                )}
                <button
                  className="flex items-center gap-2 text-small"
                  type="button"
                  disabled={!hasMakeSelected} // NEW 🔒
                  onClick={() => {
                    if (!hasMakeSelected) {
                      toast.error("Select a make first!");
                      return;
                    }
                    addCustomModel();
                  }}
                >
                  <IoMdAdd />{" "}
                  <p className="text-md sm:text-xs">Add Your Model</p>
                </button>
              </div>
            ) : (
              */}
            {!show && !showModel ? (
              <div className="mb-2 md:mb-0 border-2 border-white md:border-none">
                <Select
                  isDisabled={!hasMakeSelected}
                  labelPlacement="outside"
                  variant="bordered"
                  className="w-full mb-2 "
                  label="Model"
                  placeholder={hasMakeSelected ? "Model" : "Select make first"}
                  isRequired
                  {...register("model", { required: true })}
                >
                  {model.map(
                    (item) =>
                      item?.id !== 0 && (
                        <SelectItem key={item.id} className="capitalize">
                          {item.name.toLowerCase()}
                        </SelectItem>
                      )
                  )}
                </Select>

                {errors.model && (
                  <p className="text-xs text-red-500 pl-2 pt-2">
                    Select the model
                  </p>
                )}

                {/* ---- Add Your Model button ---- */}
                <button
                  className="flex items-center gap-2 text-small"
                  type="button"
                  // disabled={!hasMakeSelected}
                  onClick={() => {
                    if (!hasMakeSelected) {
                      toast.error("Select a make first!");
                      return;
                    }
                    addCustomModel();
                  }}
                >
                  <IoMdAdd />
                  <p className="text-md sm:text-xs">Add Your Model</p>
                </button>
              </div>
            ) : (
              <>
                <div className="relative  border-2 border-white mt-2 md:border-none md:mt-0 ">
                  <p className="text-red-500  absolute left-24 -top-1">*</p>
                  <Input
                    type="text"
                    label="Custom Model"
                    variant="bordered"
                    className=" w-full"
                    labelPlacement={"outside"}
                    placeholder="Custom Model"
                    {...register("custom_model", { required: false })}
                  />
                  <button
                    className="flex items-center gap-1 text-xs px-1 py-1 border border-gray-500 rounded-md shadow-sm bg-[#8EBFE8]  transition duration-200"
                    type="button"
                    onClick={() => {
                      setShowModel(false);
                      setShow(false); // ✅ Reset custom make mode
                    }}
                  >
                    <IoMdArrowBack className="text-sm" />
                    <p>Return</p>
                  </button>
                </div>
              </>
            )}

            {/* -------------------- Year selection -------------------- */}
            <div className="mb-2 sm:mb-0  border-2 border-white mt-2 md:border-none">
              <Select
                labelPlacement="outside"
                variant="bordered"
                className="w-full mb-2"
                label="Year"
                placeholder="Select Year"
                {...register("year", { required: true })}
                isRequired={true}
              >
                {Array.from(
                  { length: new Date().getFullYear() - 1959 },
                  (_, i) => (new Date().getFullYear() - i).toString()
                ).map((year) => (
                  <SelectItem key={year} value={year}>
                    {year}
                  </SelectItem>
                ))}
              </Select>
              {errors.year && (
                <p className="text-xs text-red-500 pl-2 pt-2">
                  Select the Year
                </p>
              )}
            </div>
            {/* -------------------- Body Style -------------------- */}
            <div className="mb-2 sm:mb-0 self-start  border-2 border-white mt-2 md:border-none">
              <Select
                labelPlacement={"outside"}
                placeholder="Body Style"
                variant="bordered"
                className="mb-2"
                label="Body Style"
                {...register("body_Style")}
              >
                {body_style?.map(
                  (item) =>
                    item?.id !== 0 && (
                      <SelectItem
                        key={item.id}
                        value={item.id}
                        className="capitalize"
                      >
                        {item.name.toLowerCase()}
                      </SelectItem>
                    )
                )}
                {body_style.length === 0 && (
                  <SelectItem key={" "} value={" "}>
                    No Items
                  </SelectItem>
                )}
              </Select>
            </div>

            {/* -------------------- Parts selector -------------------- */}
            <div className="col-span-2  border-2 border-white mt-2 md:border-none">
              {fields?.map((field, index) => (
                <div
                  key={field.id}
                  className="mb-2 md:mb-0 block md:grid md:grid-cols-2 items-center gap-4"
                >
                  {/* Part type */}
                  <div className="mb-2 md:mb-0">
                    Select Part Type <span className="text-red-500">*</span>
                    <Controller
                      name={`parts.${index}.part_id`}
                      control={control}
                      defaultValue={field.part_id || ""}
                      rules={{
                        required: "Select the part type",
                        valueAsNumber: true,
                      }}
                      render={({ field: controllerField }) => {
                        return (
                          <CreatableSelect
                            {...controllerField}
                            label="Select Part Type"
                            labelPlacement={"outside"}
                            options={options}
                            className="container capitalize "
                            classNamePrefix="custom"
                            value={options.find((option) => {
                              if (!isNaN(controllerField?.value)) {
                                return option.value === controllerField.value;
                              } else {
                                return combinedOption.includes(
                                  controllerField.value
                                );
                              }
                            })}
                            onChange={(selectedOption) => {
                              controllerField.onChange(selectedOption.value);
                              handleChange(selectedOption);
                            }}
                            onCreate={handleCreate}
                          />
                        );
                      }}
                    />
                    {errors?.parts?.[index]?.part_id && (
                      <p className="text-xs text-red-500 pl-2">
                        {errors.parts[index].part_id.message}
                      </p>
                    )}
                  </div>

                  {/* Quantity */}
                  <div className="mb-2 md:mb-0  border-2 border-white mt-2 md:border-none">
                    <Controller
                      name={`parts.${index}.quantity`}
                      control={control}
                      defaultValue={field.quantity || ""}
                      rules={{ required: false, valueAsNumber: true }}
                      render={({ field }) => (
                        <Input
                          {...field}
                          type="number"
                          label="Quantity"
                          variant="bordered"
                          className="mt-1"
                          labelPlacement={"outside"}
                          onWheel={(e) => e.target.blur()}
                          placeholder="1"
                          onKeyDown={(e) => {
                            if (
                              !/[0-9]/.test(e.key) &&
                              e.key !== "Backspace" &&
                              e.key !== "Delete"
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      )}
                    />
                    {removeVisible && (
                      <button
                        className="flex items-center gap-2 text-small float-right"
                        type="button"
                        onClick={() => remove(index)}
                      >
                        <GoDash />
                        <p className="text-md sm:text-xs">Remove</p>
                      </button>
                    )}
                  </div>
                </div>
              ))}
              <button
                type="button"
                className="flex items-center gap-2 text-small"
                onClick={addCustomField}
              >
                <IoMdAdd /> <p className="sm:text-xs">Add Your Part Type</p>
              </button>
            </div>

            {/* -------------------- Transmission -------------------- */}
            <div className="mb-2 md:mb-0  border-2 border-white mt-2 md:border-none">
              <Select
                labelPlacement={"outside"}
                placeholder="Transmission"
                variant="bordered"
                className="w-full outline-none"
                label="Transmission"
                {...register("transmission", {
                  setValueAs: (value) => (value ? Number(value) : undefined),
                })}
              >
                {transmission?.map(
                  (item) =>
                    item?.id !== 0 && (
                      <SelectItem
                        key={item.id}
                        value={String(item.id)}
                        className="capitalize"
                      >
                        {item.name.toLowerCase()}
                      </SelectItem>
                    )
                )}
              </Select>
            </div>

            {/* -------------------- Fuel Type -------------------- */}
            <div className="mb-2 md:mb-0  border-2 border-white mt-2 md:border-none">
              <Select
                labelPlacement={"outside"}
                placeholder="Fuel Type"
                variant="bordered"
                className="w-full outline-none"
                label="Fuel Type"
                {...register("fuel_type", {
                  setValueAs: (value) => (value ? Number(value) : undefined),
                })}
              >
                {fuel_type?.map(
                  (item) =>
                    item?.id !== 0 && (
                      <SelectItem
                        key={item.id}
                        value={String(item.id)}
                        className="capitalize"
                      >
                        {item.name.toLowerCase()}
                      </SelectItem>
                    )
                )}
              </Select>
            </div>

            {showVehicleDetails && (
              <div className="mb-4 p-3 border rounded-lg bg-gray-50   border-white mt-2 md:border-none">
                <RadioGroup
                  orientation="horizontal"
                  value={vehicleOpt}
                  onValueChange={setVehicleOpt}
                  className="mb-3"
                >
                  <Radio value="rego">Rego</Radio>
                  <Radio value="vin">VIN</Radio>
                  <Radio value="note">I don't have either</Radio>
                </RadioGroup>
                {vehicleOpt === "rego" && (
                  <Input
                    type="text"
                    label=""
                    variant="bordered"
                    className="mb-2"
                    labelPlacement="outside"
                    placeholder="Enter rego"
                    maxLength={10}
                    // {...register("rego", {
                    //   validate: (value) =>
                    //     vehicleOpt !== "rego" || (value && value.trim() !== ""),
                    // })}
                    {...register("rego")}
                  />
                )}
                {vehicleOpt === "vin" && (
                  <Input
                    type="text"
                    label=""
                    variant="bordered"
                    className="mb-2"
                    labelPlacement="outside"
                    placeholder="Enter VIN (17 characters)"
                    maxLength={17}
                    // {...register("vin", {
                    //   validate: (value) =>
                    //     vehicleOpt !== "vin" || (value && value.trim() !== ""),
                    // })}
                    {...register("vin")}
                  />
                )}
                {vehicleOpt === "note" && (
                  <Textarea
                    label=""
                    variant="bordered"
                    className="mb-2"
                    labelPlacement="outside"
                    placeholder="Describe vehicle details"
                    // {...register("prof_descreption", {
                    //   validate: (value) =>
                    //     vehicleOpt !== "note" || (value && value.trim() !== ""),
                    // })}
                    {...register("prof_descreption")}
                  />
                )}
                {/* {errors.rego && vehicleOpt === "rego" && (
                  <p className="text-xs text-red-500 pl-2 pt-1">
                    Rego is required
                  </p>
                )}
                {errors.vin && vehicleOpt === "vin" && (
                  <p className="text-xs text-red-500 pl-2 pt-1">
                    VIN is required
                  </p>
                )}
                {errors.prof_descreption && vehicleOpt === "note" && (
                  <p className="text-xs text-red-500 pl-2 pt-1">
                    Note is required
                  </p>
                )} */}
                {/* show this note only for VIN */}
                {vehicleOpt === "vin" && (
                  <p className="text-sm text-gray-600 mt-2">
                    (Accept up to 17 alphanumeric characters)
                  </p>
                )}{" "}
                {vehicleOpt === "note" && (
                  <p className="text-sm text-gray-600 mt-2">
                    (Please include as much information as possible about the
                    vehicle and upload clear photos of the part required. This
                    will help us ensure accuracy and fast turnaround)
                  </p>
                )}
              </div>
            )}

            <div className="mb-2 sm:mb-0">
              <Input
                label="Upload Images (Max 5 Images)"
                type="file"
                multiple
                disabled={images.length >= 5}
                accept="image/*"
                labelPlacement="outside"
                placeholder="Choose images"
                {...register("images")}
                onChange={uploadImage}
                className={
                  images.length >= 5 ? "opacity-60 cursor-not-allowed" : ""
                }
                classNames={{
                  input:
                    "file:bg-blue-600 file:hover:bg-blue-700 " +
                    "file:text-white file:font-medium " +
                    "file:px-4 file:py-2 " +
                    "file:rounded-md file:border-0 file:cursor-pointer " +
                    "file:ml-0",
                  inputWrapper: "gap-0 px-0",
                }}
              />

              <p className="text-sm text-gray-500 mt-1">
                {images.length}/5 images uploaded
              </p>
            </div>

            <div className="col-span-2">
              <Textarea
                key={"bordered"}
                variant={"bordered"}
                label="Notes"
                labelPlacement="outside"
                placeholder="Any Message"
                {...register("notes")}
              />
            </div>
          </QuoteLayout>
          {/* <button
            type="submit"
            className="h-9 bg-lightBlue text-white rounded-lg py-1 px-5 mt-6"
            // disabled={isSubmitting}
          >
            {/* {isSubmitting ? "Submitting…" : "Submit"} */}
          {/* Submit */}
          {/* </button> */}
          <Button
            type="submit"
            className="h-9 mt-6"
            color="primary"
            isDisabled={isSubmitting} // ✅ NEW
          >
            {isSubmitting ? (
              <>
                <Spinner size="sm" /> &nbsp;Submitting…
              </>
            ) : (
              "Submit"
            )}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default RequestGen;
